import React, {Fragment, useEffect, useState} from 'react';
import {Route, Switch, useParams} from "react-router";
import StickersScreensNewStickerFormat from "../new-sticker-format";
import StickersScreensNewStickerMediaPhoto from "../new-sticker-media-photo";
import StickersScreensNewStickerMediaVideo from "../new-sticker-media-video";
import StickersScreensNewStickerMediaAudio from "../new-sticker-media-audio";
import StickersScreensNewStickerTheme from "../new-sticker-theme";
import StickersScreensNewStickerMessage from "../new-sticker-message";
import StickersScreensNewPreview from "../preview";
import StickerScreensNewVideoRecord from "../new-video-record";
import StickersScreensNewFinish from "../new-sticker-finish";
import ErrorScreen from "../../../../layout/ui/screens/error";
import {addStickerItem} from "../../../store/sticker-show/actions";
import { useDispatch, useSelector } from "react-redux";
import LayoutComponentsLoaderProcessing from "../../../../layout/ui/components/loader-processing";
import { isMemorialType } from "../../../store/sticker-show/selectors";

export default function StickerScreensNew(props) {
    const {id: stickerId}: { id: string } = useParams();
    const [isAddingNewItem, setIsAddingNewItem] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);
    const dispatch: (any) => Promise<any>  = useDispatch();
    const isStickerTypeMemorial = useSelector(isMemorialType);
    isStickerTypeMemorial && props.appThemeChanger('setMemorialTheme');

    useEffect(() => {
        dispatch(addStickerItem(stickerId))
            .then(() => {
                if (stickerId) {
                    localStorage.setItem('stickerForContinue', stickerId);
                }
            })
            .catch(() => setIsError(true))
            .then(() => setIsAddingNewItem(false))
        ;
    }, [stickerId])

    if (isError) {
        return <ErrorScreen/>
    }

    if (isAddingNewItem) {
        return <LayoutComponentsLoaderProcessing isMemorialTheme={ isStickerTypeMemorial } show={true}/>
    }

    return <Fragment>
        <Switch>
            <Route exact path="/stickers/:id/new/photo" component={StickersScreensNewStickerMediaPhoto}/>
            <Route exact path="/stickers/:id/new/video" component={StickersScreensNewStickerMediaVideo}/>
            <Route exact path="/stickers/:id/new/audio" component={StickersScreensNewStickerMediaAudio}/>
            <Route exact path="/stickers/:id/new/theme" component={StickersScreensNewStickerTheme}/>
            <Route exact path="/stickers/:id/new/message" component={StickersScreensNewStickerMessage}/>
            <Route exact path="/stickers/:id/new/preview" component={StickersScreensNewPreview}/>
            <Route exact path="/stickers/:id/new/video-record" component={StickerScreensNewVideoRecord}/>
            <Route exact path="/stickers/:id/new/finish" component={StickersScreensNewFinish}/>
            <Route exact path="/stickers/:id/new" component={StickersScreensNewStickerFormat}/>
            <Route component={ErrorScreen}/>
        </Switch>
    </Fragment>
}





// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/new-sticker/index.tsx